export const ACTION_NAME = 'ACTION_NAME';
export const ACTIVE_PAGE = 'ACTIVE_PAGE';
export const NO_HEADER = 'NO_HEADER';

/* ********************* */
/* Create Inform Actions */
/* ********************* */
export const MORE_GRAPHICS = 'MORE_GRAPHICS';
export const LESS_GRAPHICS = 'LESS_GRAPHICS';
export const ACCOMULATE_INFORM = 'ACCOMULATE_INFORM';
export const RESIZE_ELEMENT = 'RESIZE_ELEMENT';
export const MOVE_ELEMENT = 'MOVE_ELEMENT';
export const BACK_GRAPHIC = 'BACK_GRAPHIC';
export const CREATE_COPY = 'CREATE_COPY';
export const DELETE = 'DELETE';
export const MORE_TEXT = 'MORE_TEXT';
export const EDIT_TEXT = 'EDIT_TEXT';
export const CHANGE_CLASS_TEXTS = 'CHANGE_CLASS_TEXTS';
export const SELECT_SHIELD = 'SELECT_SHIELD';
export const OPEN_FILE = 'OPEN_FILE';
export const DELETE_DATA = 'DELETE_DATA';


/* ********************* */
/*      Modal Actions    */
/* ********************* */

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_LOADER = 'OPEN_LOADER';
export const CLOSE_LOADER = 'CLOSE_LOADER';


/* ********************* */
/*       User Session    */
/* ********************* */

export const LOGIN_ACCOUNT = 'LOGIN_ACCOUNT';
export const LOGIN_ASYNC_ACCOUNT = 'LOGIN_ASYNC_ACCOUNT';
export const ERROR_LOGIN = 'ERROR_LOGIN';
export const CLOSE_SESSION = 'CLOSE_SESSION';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';


/* ********************* */
/*       Dashboard       */
/* ********************* */

export const SELECT_FILTER_CHARACTERISTIC = "SELECT_FILTER_CHARACTERISTIC"
export const SELECT_FILTER_FENOMENE = "SELECT_FILTER_FENOMENE"
export const SELECT_FILTER_TIME = "SELECT_FILTER_TIME"
export const SIGNAL_UPDATE = "SIGNAL_UPDATE"
export const SIGNAL_POINT = "SIGNAL_POINT"
export const ADDED_POINT = "ADDED_POINT"
export const POINTS_TO_SHOW = "POINTS_TO_SHOW"

/* ********************* */
/*       System Config   */
/* ********************* */

export const URL_LOGO = 'SET_LOGO';